import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

// Avoid calling i18n._ at module load. Compute on demand after locale activation.
export function getCircleExamples(): string[] {
  return [
    i18n._(
      msg({
        message: "Ask Tally about your revenue.",
        context: "Circle view example prompt",
      }),
    ),
    i18n._(
      msg({
        message: "Ask Tally about your largest customers.",
        context: "Circle view example prompt",
      }),
    ),
    i18n._(
      msg({
        message: "Ask Tally to make a chart.",
        context: "Circle view example prompt",
      }),
    ),
    i18n._(
      msg({
        message: "Ask Tally to compare accounts.",
        context: "Circle view example prompt",
      }),
    ),
    i18n._(
      msg({
        message: "Ask Tally about your newest customers.",
        context: "Circle view example prompt",
      }),
    ),
    i18n._(
      msg({
        message: "Ask Tally about your budget vs. actuals.",
        context: "Circle view example prompt",
      }),
    ),
    i18n._(
      msg({
        message: "Ask Tally why an account fluctuates.",
        context: "Circle view example prompt",
      }),
    ),
    i18n._(
      msg({
        message: "Ask Tally about your open invoices.",
        context: "Circle view example prompt",
      }),
    ),
    i18n._(
      msg({
        message: "Ask Tally about your key metrics.",
        context: "Circle view example prompt",
      }),
    ),
    i18n._(
      msg({
        message: "Ask Tally for a forecast.",
        context: "Circle view example prompt",
      }),
    ),
  ];
}
